"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const utils_1 = require("../../utils");
exports.TableCell = styled_1.default.td((props) => ({
    paddingBottom: 4,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 4,
    textAlign: props.align,
    whiteSpace: props.nowrap ? 'nowrap' : 'normal',
    '> *': {
        verticalAlign: 'middle',
    },
    [(0, utils_1.mediaBreakpointGte)('md')]: {
        paddingBottom: 10,
        paddingTop: 10,
    },
}));
